import Layout from "../../components/layouts/layout.comp";
import MaterialEditor from "../../components/material/materialEditor.comp";
import { EditingMode } from "../../components/reuseables/form.comp";
import { useTranslation } from "../../core/translation.core";

export default function MaterialCreatePage() {
  const { t, msg } = useTranslation();

  return (
    <Layout title={t(msg.material.add)}>
      <h1>{t(msg.material.add)}</h1>
      <MaterialEditor editingMode={EditingMode.create} />
    </Layout>
  );
}
